export default __webpack_public_path__ + "static/media/img25.a537c15a.jpg";